module.exports = __webpack_public_path__ + "static/media/origami7.46db6966.jpg";